import React from 'react';
import { Link } from 'react-router-dom';
import { ArchImage, ArrowLink, Label, Mullions, Reveal } from './System';
import Icon from './Icon';

// Closing section: a statement of intent on limestone, with a plate that crosses the seam into the footer.
function CtaSection({ eyebrow, title, subtitle, primary, secondary, image = 'entrance' }) {
  return (
    <section className="relative z-10 border-t border-wall/20 bg-limestone">
      <Mullions />
      <div className="shell">
        <div className="grid-12 relative items-end">
          <Reveal className="col-span-4 py-16 lg:col-span-6 lg:py-28">
            {eyebrow && <Label className="mb-5">{eyebrow}</Label>}
            <h2 className="type-h2">{title}</h2>
            {subtitle && <p className="type-lead mt-5 text-glass">{subtitle}</p>}
            <div className="mt-9 flex flex-wrap items-center gap-x-7 gap-y-3">
              {primary && (
                <Link to={primary.to} className="btn-primary">
                  {primary.label}
                  <Icon name="arrow" size={16} />
                </Link>
              )}
              {secondary && <ArrowLink to={secondary.to}>{secondary.label}</ArrowLink>}
            </div>
          </Reveal>
          <div className="col-span-4 lg:col-span-5 lg:col-start-8">
            <ArchImage
              name={image}
              sizes="(min-width: 1024px) 42vw, 100vw"
              className="-mb-14 h-[240px] w-full shadow-panel sm:h-[320px] lg:-mb-20 lg:h-[420px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaSection;
